import React, { useState } from 'react';
import { ButtonText, Button } from 'core/controls/button/Button';
import { SvgIcon } from 'core/icons';
import { Translate, useTranslate } from '../../../core/translate';
import { useModelInfo } from '../../common/ModelInfoContext';
import { combineClassNames } from '../../../core/css';

const Chat = ({ alt, analyticsKey = 'contact' }) => {
  const { enableChat, hasTransactionId, liveChatType } = useModelInfo();
  const translate = useTranslate();
  const chatAriaLabel = translate('chat.button.aria.label.v3');
  const [salesforceChatOpen, setSalesForceChatOpen] = useState(false);

  const launchChat = () => {
    if (enableChat) {
      if (liveChatType === 'salesforce') {
        window.SFM_LaunchChat();
      } else {
        const liveChatNode = document.getElementById('Build_Your_Own_Button')
          .childNodes[0];
        if (liveChatNode) {
          liveChatNode.click();
        }
        return false;
      }
    }
  };

  const mutationObserver = new MutationObserver(() => {
    const embeddedMessagingFilePreview = document.getElementById(
      'embeddedMessagingFilePreviewFrame'
    );
    if (document.body.contains(embeddedMessagingFilePreview)) {
      setSalesForceChatOpen(true);
    } else {
      setSalesForceChatOpen(false);
    }
  });

  mutationObserver.observe(document.body, {
    childList: true,
  });

  return (
    <>
      {hasTransactionId || !enableChat || salesforceChatOpen ? null : (
        <Button
          className={combineClassNames(
            'chat__button',
            'stat-button-link',
            alt ? 'chat__button--alt' : ''
          )}
          onClick={launchChat}
          data-dtm={analyticsKey}
          role={'complementary'}
          aria-label={chatAriaLabel}>
          <SvgIcon
            className={combineClassNames(
              'chat__button__icon',
              'button__icon--left'
            )}
            name="chat"
          />
          <ButtonText className="chat__button__text">
            <Translate value="chat.cta.label.v3" />
          </ButtonText>
        </Button>
      )}
    </>
  );
};

export default Chat;
